var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16981_8910)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_16981_8910)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.55083 16.837C1.07214 14.1222 3.01243 11.5108 5.8846 11.0044L37.0877 5.50244C39.9599 4.996 42.6763 6.78623 43.155 9.50103L46.622 29.1633C47.1007 31.8781 45.1604 34.4895 42.2882 34.9959L11.0851 40.4979C8.21293 41.0043 5.49652 39.2141 5.01783 36.4993L1.55083 16.837Z",
    fill: "url(#paint0_linear_16981_8910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94904 15.7241C4.85314 15.1802 5.2163 14.6615 5.7602 14.5656L38.5721 8.77999C39.116 8.68409 39.6346 9.04726 39.7305 9.59115L41.0135 16.867L6.23198 23L4.94904 15.7241Z",
    fill: "#E6E5FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16981_8910",
    x1: 19.1825,
    y1: 18.4955,
    x2: 8.22599,
    y2: 42.0111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#A2A0FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16981_8910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.0859375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_16981_8910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.246,
    height: 42.246,
    fill: "white",
    transform: "translate(-0.383789 5.86597) rotate(-10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.5ed19951a290c347edda90694bc9b322.svg";
export { ForwardRef as ReactComponent };